






import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {FusionThemesDefault, WidgetDefinition, WSize} from '@/components/widgets/WidgetFather'
import WidgetFrame from '@/components/WidgetFrame.vue'
import FusionChart from '@/components/charts/FusionChart.vue'
import {bus} from '@/main'
import {getJobsAllocatedInAMonth} from '@/data/sources/jobsAllocatedInAMonth'

const drillDown = () => ({
  component: import('@/components/drilldowns/SkanskaPPMDrillDown.vue'),
  delay: 200,
  timeout: 3000,
})

@Component({
  components: {
    FusionChart,
    WidgetFrame,
  },
})
export default class SkanskaPPM extends Vue {
  @Prop() public config!: WidgetDefinition
  private chartDS: object = {}
  private chartConfig = {
    title: 'Skanska ppm jobs completed for month to date',
    type: 'pie3d',
    width: WSize.dbl.w,
    height: WSize.dbl.h,
    chartDataFormat: 'json',
  }
  private chartDataConfig = {
    caption: '',
    subcaption: '',
    yaxisname: '',
    xaxisname: '',
    numbersuffix: '',
    rotatelabels: '1',
    setadaptiveymin: '1',
    theme: 'micad',
    showlegend: '1',
    labelDisplay: 'none',
    showLabels: '0',
    showValues: '0',
    legendCaption: 'Legend',
  }

  @Watch('config', {immediate: true, deep: true})
  public onConfigChange(val: WidgetDefinition) {
    this.chartConfig.type = val.cType || 'pie3d'
    this.chartDataConfig.theme = val.theme || FusionThemesDefault
  }

  private currentMonth: number = new Date().getMonth() + 1
  private currentYear: number = new Date().getFullYear()

  public async created() {

    this.chartDS = {
      chart: this.chartDataConfig,
      data: await getJobsAllocatedInAMonth(1, this.currentMonth, this.currentYear, 1, 0, 29, 0),
    }
  }

  public async chartClickCallback(label: string, val: any) {
    console.log('chartClickCallback', label, val)
    bus.$emit('chartPopup', {
      title: 'Completed PM Jobs for Month to Date : Category Filter - 2 Contractor Filter - 29',
      component: drillDown,
    })
  }
}
